import React from 'react';
import PropTypes from 'prop-types';
import TeamCard from '../../components/widgets/TeamCard';
import VerbHeading from '../../../shared/components/VerbHeading';

const TeamsDiscoverRow = (props) => {
    const { userTeams = [], cardBackgroundColor = 'eggshell', onCardClick = () => {} } = props;

    const teamsToDisplay = userTeams.slice(0, 2); // sorted by desc updatedOn
    return teamsToDisplay.length ? (
        <div className={'collection-row'}>
            <div className={'container'}>
                <VerbHeading messageId={'YOUR_TEAMS'} hNumber={5} formatIntl={false} customMessage={'Your Teams'} />
                <div className={'row'}>
                    {teamsToDisplay.map((team, index) => (
                        <TeamCard
                            className={'col-sm-6 col-12'}
                            team={team}
                            index={index}
                            cardBackgroundColor={cardBackgroundColor}
                            onClick={() => {
                                onCardClick(team);
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    ) : null;
};

TeamsDiscoverRow.propTypes = {
    userTeams: PropTypes.array,
    onCardClick: PropTypes.func,
    cardBackgroundColor: PropTypes.oneOf(['eggshell', 'white'])
};

export default TeamsDiscoverRow;
